import { WithdrawForm } from "@/components/form/WithdrawForm";
import { DialogContent } from "@/components";

export function WithdrawFormDialog() {
    return (
        <DialogContent>
            <WithdrawForm isDialog />
        </DialogContent>
    );
}
